import { defineMessages } from 'react-intl'

export const servicesItems = defineMessages({
  '1.title': {
    id: 'components.Nav.servicesItems.1.title',
    defaultMessage: 'Voice Casting and Auditions',
  },
  '1.href': {
    id: 'components.Nav.servicesItems.1.href',
    defaultMessage:
      'https://www.voicearchive.com/voice-casting-and-auditions/',
  },
  '2.title': {
    id: 'components.Nav.servicesItems.2.title',
    defaultMessage: 'Live Recording on Assets',
  },
  '2.href': {
    id: 'components.Nav.servicesItems.2.href',
    defaultMessage: 'https://www.voicearchive.com/live-sessions/',
  },
  '3.title': {
    id: 'components.Nav.servicesItems.3.title',
    defaultMessage: 'Audio Post',
  },
  '3.href': {
    id: 'components.Nav.servicesItems.3.href',
    defaultMessage: 'https://www.voicearchive.com/audio-post-services/',
  },
})

export default defineMessages({
  explore: {
    id: 'components.Nav.explore',
    defaultMessage: 'Find Voices',
  },
  exploreByLanguage: {
    id: 'components.Nav.exploreByLanguage',
    defaultMessage: 'Our voices',
  },
  startProject: {
    id: 'components.Nav.start',
    defaultMessage: 'Find Voice',
  },
  services: {
    id: 'components.Nav.services',
    defaultMessage: 'Services',
  },
  servicesHref: {
    id: 'components.Nav.services.href',
    defaultMessage: 'https://www.voicearchive.com/services/',
  },
  pricing: {
    id: 'components.Nav.pricing',
    defaultMessage: 'Pricing',
  },
  pricingHref: {
    id: 'components.Nav.pricing.href',
    defaultMessage: 'https://www.voicearchive.com/voice-over-pricing/',
  },
  cases: {
    id: 'components.Nav.cases',
    defaultMessage: 'Cases',
  },
  casesHref: {
    id: 'components.Nav.cases.href',
    defaultMessage: 'https://www.voicearchive.com/cases/',
  },
  contact: {
    id: 'components.Nav.contact',
    defaultMessage: 'Contact',
  },
  contactHref: {
    id: 'components.Nav.contact.href',
    defaultMessage: 'https://www.voicearchive.com/contact/',
  },
  apply: {
    id: 'components.Nav.apply',
    defaultMessage: 'Apply as speaker',
  },
  applyHref: {
    id: 'components.Nav.apply.href',
    defaultMessage: 'https://www.voicearchive.com/apply-voice-talent/',
  },
  aboutUs: {
    id: 'components.Nav.aboutUs',
    defaultMessage: 'About us',
  },
  aboutUsHref: {
    id: 'components.Nav.aboutUs.href',
    defaultMessage: 'https://www.voicearchive.com/about-voicearchive/',
  },
  logIn: {
    id: 'components.Nav.login',
    defaultMessage: 'Log In',
  },
  contactUs: {
    id: 'components.Nav.contactUs',
    defaultMessage: 'Contact us',
  },
})
